import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-263f74a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1))
const _hoisted_4 = { class: "row mt-5" }
const _hoisted_5 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_icon_floppy_fill = _resolveComponent("b-icon-floppy-fill")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.modelValue.count == 1)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [
          _createTextVNode("En ny opgave blev gemt "),
          _createVNode(_component_b_icon_floppy_fill)
        ]))
      : (_openBlock(), _createElementBlock("h2", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.modelValue.count) + " nye opgaver blev gemt ", 1),
          _createVNode(_component_b_icon_floppy_fill)
        ])),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-success",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('startOver')))
        }, " Opret flere Jobs ")
      ])
    ])
  ], 64))
}